/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileLaz = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M9.566 16.041h2.208V17H8.49v-5.017h1.076zM16.99 17h-1.2l-.333-1.028h-1.85L13.276 17h-1.152l1.904-5.017h1.042zm-3.093-1.938h1.266l-.637-1.972zm7.229-2.333-2.375 3.36h2.465V17h-3.822v-.766l2.36-3.34h-2.278v-.91h3.65z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileLaz as FileLaz };
